export default __webpack_public_path__ + "static/media/Atlas Favicon 2.0 (1).79e416b8.png";